"use client";

import React from "react";
import styles from "./layout.module.scss";
import { useMobile } from "@/hooks/use-responsive";
import Sidebar from "@/components/sidebar/sidebar";
import MobileHeader from "@/components/header/mobile-header/mobile-header";

const InfoLayout = ({ children }: any) => {
  const { isMobile } = useMobile();

  return (
    <main className={styles.main}>
      {!isMobile && <Sidebar />}
      <div className={styles.home_content}>
        {isMobile && <MobileHeader />}
        {children}
      </div>
    </main>
  );
};

export default InfoLayout;
